import { CommandGroup, CommandItem } from "@/components/ui/command";
import { StatusIcon } from "@/components/ui/icons";
import { Text } from "@/components/ui/text";
import type { TAccessionStatus } from "@/lib/types";
import { useAccessionCommands } from "../AccessionCommands";
import { useAccession } from "../AccessionProvider";

export const statusCommands: {
  status: TAccessionStatus;
  label: string;
  disableOn?: TAccessionStatus[];
}[] = [
  { status: "new", label: "New" },
  { status: "received", label: "Received" },
  { status: "in_progress", label: "In progress", disableOn: ["new"] },
  { status: "completed", label: "Completed", disableOn: ["new"] },
  { status: "final", label: "Final", disableOn: ["new"] },
  { status: "cancelled", label: "Cancelled" },
];

export function SetStatusCommands() {
  const { accession } = useAccession();
  const { setStatus } = useAccessionCommands();

  return (
    <CommandGroup heading="Set accession status">
      {statusCommands.map(({ status, label, disableOn }) => (
        <CommandItem
          key={status}
          onSelect={() => setStatus(status)}
          disabled={
            accession.status === status || disableOn?.includes(accession.status)
          }
        >
          <StatusIcon status={status} />
          <Text>{label}</Text>
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
